import React from 'react'
import ReserveManualModal, { openReserveManualModal } from './ReserveManualModal'
import ReserveAutoModal, { openReserveAutoModal } from './ReserveAutoModal'

const Modals = ({ onRefresh }) => (
  <div>
    <ReserveManualModal onRefresh={onRefresh} />
    <ReserveAutoModal onRefresh={onRefresh} />
  </div>
)

export { openReserveManualModal, openReserveAutoModal }

export default Modals
